module.exports = __webpack_public_path__ + "static/media/check-default.6639d1cd.svg";